






























































import { Component, Vue } from "vue-property-decorator";

type states = "entrance" | "countdown" | "playing" | "end" | "result";

@Component
export default class RhythmFlash extends Vue {
  private timeLimit = 30;
  public remainingTime = this.timeLimit;
  public rhythms = [
    { name: "ス", cols: "6" },
    { name: "ナス", cols: "6" },
    { name: "ヤキトリ", cols: "6" },
    { name: "ピーナツ", cols: "6" },
    { name: "コロッケ", cols: "4" },
    { name: "トマト", cols: "4" },
    { name: "ティーンパ", cols: "4" },
  ];
  private countdown = -1;
  private currentState: states = "entrance";
  private startTime!: number;
  public rhythmIndex = -1;
  private incorrect = false;
  public score!: number;

  get remainingTimePercent() {
    return (this.remainingTime / this.timeLimit) * 100;
  }

  public start() {
    this.currentState = "countdown";
    this.countdown = 3;
    this.remainingTime = this.timeLimit;
    this.score = 0;
    const me = this;
    const id = setInterval(() => {
      if (--me.countdown === 0) {
        me.countdown = -1;
        me.currentState = "playing";
        clearInterval(id);
        this.changeRhythm();
        requestAnimationFrame(me.update);
        me.startTime = new Date().getTime();
      }
    }, 1000);
  }

  private update() {
    if (this.remainingTime > 0) requestAnimationFrame(this.update);
    else {
      this.currentState = "end";
      const me = this;
      setTimeout(() => {
        me.currentState = "result";
      }, 2000);
    }
    this.remainingTime =
      this.timeLimit - (new Date().getTime() - this.startTime) / 1000;
  }

  private changeRhythm() {
    const preRhythmIndex = this.rhythmIndex;
    do {
      this.rhythmIndex = Math.floor(Math.random() * this.rhythms.length);
    } while (this.rhythmIndex === preRhythmIndex);
  }

  public answer(index: number) {
    if (this.rhythmIndex === index) {
      this.score += 10;
      this.changeRhythm();
    } else {
      this.incorrect = true;
      setTimeout(() => (this.incorrect = false), 300);
    }
  }
}
